import { render } from "./Excerpt.vue?vue&type=template&id=758b25a0"
import script from "./Excerpt.vue?vue&type=script&lang=js"
export * from "./Excerpt.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nazikban/projects/credit-west-second/packages/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Excerpt.vue"]])

export default __exports__